module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-560.8d9981b3.jpg";